import styled from "styled-components";
import { P1 } from "./Paragraph";
import { color as themeColor, fonts } from "@styles";
import { FC } from "react";
import { Card } from "../templates/Card";

interface Props {
  id?: string;
  pt?: string;
  pb?: string;
  background?: string;
}

export const TalkToUs: FC<React.PropsWithChildren<Props>> = ({ id, pt, pb, background }) => (
  <section id={id} aria-labelledby={`${id}-talktous-title`}>
    {" "}
    <Card pt={pt} pb={pb} background={background} cardColor="transparent">
      <div>
        <StyledH3 id={`${id}-talktous-title`}>Prefer to talk to us?</StyledH3>
        <Flex>
          <Column>
            <Paragraph>
              We’ve got someone ready to speak to you. Our lines are open from 8am to 6pm, Monday to
              Friday.
            </Paragraph>
            <Outgoing>
              <LinkHeader>Phone: </LinkHeader>
              <a href="tel:+44 (0)20 3870 2604">
                <StyledLink>+44 (0)20 3870 2604</StyledLink>
              </a>
            </Outgoing>
          </Column>
          <Column>
            <Paragraph>
              You can also write to us and we’ll endeavour to respond to your email as soon as we
              possibly can:
            </Paragraph>
            <Outgoing>
              <LinkHeader>Email: </LinkHeader>
              <a href="mailto:hello@yulife.com">
                <StyledLink>hello@yulife.com</StyledLink>
              </a>
            </Outgoing>
          </Column>
        </Flex>
      </div>
    </Card>
  </section>
);

const Container = styled.div`
  width: 100%;
  max-width: 58rem;
  margin: 0 auto;
  border-radius: 0.5rem;

  @media only screen and (max-width: 65rem) {
    padding: 0 3.5rem;
  }

  @media only screen and (max-width: 45rem) {
    padding: 0 1.75rem;
    border-radius: 0;
  }
`;

const StyledH3 = styled.h3`
  font-family: ${fonts.body};
  font-weight: bold;
  font-size: 1.5rem;
  font-weight: normal;
  letter-spacing: 0.075rem;
  line-height: 2rem;
  margin: 0 0 1.5rem 0;
  color: ${themeColor.H100};
`;

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -1rem;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
  margin: 1rem;

  @media only screen and (max-width: 45rem) {
    flex-basis: 100%;
  }
`;

const Paragraph = styled(P1)`
  padding: 0;
  margin-bottom: 2.5rem;
`;

const Outgoing = styled.div`
  margin-top: auto;
`;

const LinkHeader = styled(P1)`
  display: inline;
  padding: 0;
`;

const StyledLink = styled(P1)`
  display: inline;
  color: ${themeColor.P100};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${themeColor.H100};
  }
`;

const Bottom = styled.div<{
  paddingTop?: string;
  paddingBottom?: string;
  backgroundColor?: string;
}>`
  padding-top: ${(p) => p.paddingTop};
  padding-bottom: ${(p) => p.paddingBottom};
  background-color: ${(p) => p.backgroundColor};
`;
